import { NgModule } from '@angular/core';
import { CategoryAdapter } from './category/category.adapter';
import { CategoryConnector } from './category/category.connector';
import { OccCategoryAdapter } from './category/occ.category.adapter';
import { NewsAdapter } from './news/news.adapter';
import { NewsConnector } from './news/news.connector';
import { OccNewsAdapter } from './news/occ.news.adapter';
import { OccPaymentAdapter } from './payment/occ.payment.adapter';
import { PaymentAdapter } from './payment/payment.adapter';
import { PaymentConnector } from './payment/payment.connector';
import { CheckoutBillingAdapter } from './checkout/billing/checkout.billing.adapter';
import { OccCheckoutBilingAdapter } from './checkout/billing/occ.checkout.biling.adapter';
import { CheckoutBillingConnector } from './checkout/billing/checkout.billing.connector';
import { OrderAdapter, OrderConnector } from '@spartacus/order/core';
import { OccOrderAdapter } from '@spartacus/order/occ';
import { CheckOrderAdapter } from './order/check-order.adapter';
import { OccCheckOrderAdapter } from './order/occ.check-order.adapter';
import { CheckOrderConnector } from './order/check-order.connector';
import { FormsAdapter } from './forms/forms.adapter';
import { OccFormsAdapter } from './forms/occ.forms.adapter';
import { FormsConnector } from './forms/forms.connector';
import { UserCurrentAdapter } from './user/user-current.adapter';
import { OccUserCurrentAdapter } from './user/occ.user-current.adapter';
import { UserCurrentConnector } from './user/user-current.connector';
import { NewsLetterConnector } from './news-letter/news-letter.connector';
import { NewsLetterAdapter } from './news-letter/news-letter.adapter';
import { OccNewsLetterAdapter } from './news-letter/occ.news-letter.adapter';
import { ProductModelSearchConnector } from './product-model-search/product-model-search.connector';
import { ProductModelSearchAdapter } from './product-model-search/product-model-search.adapter';
import { OccProductModelSearchAdapter } from './product-model-search/occ.product-model-search.adapter';
import { ProductReviewsAdapter } from '@spartacus/core';
import { OccGgProductReviewsAdapter } from './product-reviews/occ.gg-product-reviews.adapter';
import { GgInStockReminderConnector } from './in-stock-reminder/in-stock-reminder.connector';
import { GgInStockReminderAdapter } from './in-stock-reminder/in-stock-reminder.adapter';
import { OccGgInStockReminderAdapter } from './in-stock-reminder/occ.in-stock-reminder.adapter';
import { FaqConnector } from './faq/faq.connector';
import { FaqAdapter } from './faq/faq.adapter';
import { OccFaqAdapter } from './faq/occ.faq.adapter';
import { DccConnector } from './dcc/dcc.connector';
import { DccAdapter } from './dcc/dcc.adapter';
import { OccDccAdapter } from './dcc/occ.dcc.adapter';
import { LufcCustomerRegisterConnector } from './lufc-customer-register/lufc-customer-register.connector';
import { LufcCustomerRegisterAdapter } from './lufc-customer-register/lufc-customer-register.adapter';
import { OccLufcCustomerRegisterAdapter } from './lufc-customer-register/occ.lufc-customer-register.adapter';
import { GgProductHighlightsConnector } from './product-highlights/product-highlights.connector';
import { GgProductHighlightsAdapter } from './product-highlights/product-highlights.adapter';
import { OccGgProductHighlightsAdapter } from './product-highlights/occ.product-highlights.adapter';
import { PartnerLinkListConnector } from './partner-link-list/partner-link-list.connector';
import { PartnerLinkListAdapter } from './partner-link-list/partner-link-list.adapter';
import { OccPartnerLinkListAdapter } from './partner-link-list/occ.partner-link-list.adapter';
import { RecaptchaV3Connector } from './recaptcha-v3/recaptcha-v3.connector';
import { RecaptchaV3Adapter } from './recaptcha-v3/recaptcha-v3.adapter';
import { OccRecaptchaV3Adapter } from './recaptcha-v3/occ.recaptcha-v3.adapter';
import { RestoreCartConnector } from './restore-cart/restore-cart.connector';
import { RestoreCartAdapter } from './restore-cart/restore-cart.adapter';
import { OccRestoreCartAdapter } from './restore-cart/occ.restore-cart.adapter';
import { GgProductBundlesConnector } from './product-bundles/gg-product-bundles.connector';
import { GgProductBundlesAdapter } from './product-bundles/gg-product-bundles.adapter';
import { OccProductBundlesAdapter } from './product-bundles/occ.product-bundles.adapter';
import { ProductOfTheMonthConnector } from './product-of-the-month/product-of-the-month.connector';
import { ProductOfTheMonthAdapter } from './product-of-the-month/product-of-the-month.adapter';
import { OccProductOfTheMonthAdapter } from './product-of-the-month/occ.product-of-the-month.adapter';
import { ProductVerificationConnector } from './product-verification/product-verification.connector';
import { ProductVerificationAdapter } from './product-verification/product-verification.adapter';
import { OccProductVerificationAdapter } from './product-verification/occ.product-verification.adapter';
import { GgAiTroubleshootConnector } from './ai-troubleshoot/gg-ai-troubleshoot.connector';
import { GgAiTroubleshootAdapter } from './ai-troubleshoot/gg-ai-troubleshoot.adapter';
import { OccGgAiTroubleshootAdapter } from './ai-troubleshoot/occ.gg-ai-troubleshoot.adapter';
import { GgFirmwareVerificationConnector } from './firmware-verification/gg-firmware-verification-connector.service';
import { GgFirmwareVerificationAdapter } from './firmware-verification/gg-firmware-verification.adapter';
import { OccGgFirmwareVerificationAdapter } from './firmware-verification/occ-gg-firmware-verification-adapter.service';

@NgModule({
  providers: [
    {
      provide: CategoryAdapter,
      useExisting: OccCategoryAdapter,
    },
    CategoryConnector,
    {
      provide: NewsAdapter,
      useExisting: OccNewsAdapter,
    },
    NewsConnector,
    {
      provide: PaymentAdapter,
      useExisting: OccPaymentAdapter,
    },
    PaymentConnector,
    {
      provide: CheckoutBillingAdapter,
      useExisting: OccCheckoutBilingAdapter,
    },
    CheckoutBillingConnector,
    {
      provide: OrderAdapter,
      useExisting: OccOrderAdapter,
    },
    OccOrderAdapter,
    OrderConnector,
    {
      provide: CheckOrderAdapter,
      useExisting: OccCheckOrderAdapter,
    },
    CheckOrderConnector,
    {
      provide: FormsAdapter,
      useExisting: OccFormsAdapter,
    },
    FormsConnector,
    {
      provide: UserCurrentAdapter,
      useExisting: OccUserCurrentAdapter,
    },
    UserCurrentConnector,
    NewsLetterConnector,
    {
      provide: NewsLetterAdapter,
      useExisting: OccNewsLetterAdapter,
    },
    GgInStockReminderConnector,
    {
      provide: GgInStockReminderAdapter,
      useExisting: OccGgInStockReminderAdapter,
    },
    {
      provide: ProductModelSearchAdapter,
      useExisting: OccProductModelSearchAdapter,
    },
    ProductModelSearchConnector,
    {
      provide: ProductReviewsAdapter,
      useExisting: OccGgProductReviewsAdapter,
    },
    FaqConnector,
    {
      provide: FaqAdapter,
      useExisting: OccFaqAdapter,
    },
    DccConnector,
    {
      provide: DccAdapter,
      useExisting: OccDccAdapter,
    },
    {
      provide: LufcCustomerRegisterAdapter,
      useExisting: OccLufcCustomerRegisterAdapter,
    },
    LufcCustomerRegisterConnector,
    GgProductHighlightsConnector,
    {
      provide: GgProductHighlightsAdapter,
      useExisting: OccGgProductHighlightsAdapter,
    },
    PartnerLinkListConnector,
    {
      provide: PartnerLinkListAdapter,
      useExisting: OccPartnerLinkListAdapter,
    },
    RecaptchaV3Connector,
    {
      provide: RecaptchaV3Adapter,
      useExisting: OccRecaptchaV3Adapter,
    },
    RestoreCartConnector,
    {
      provide: RestoreCartAdapter,
      useExisting: OccRestoreCartAdapter,
    },
    GgProductBundlesConnector,
    {
      provide: GgProductBundlesAdapter,
      useExisting: OccProductBundlesAdapter,
    },
    ProductOfTheMonthConnector,
    {
      provide: ProductOfTheMonthAdapter,
      useExisting: OccProductOfTheMonthAdapter,
    },
    ProductVerificationConnector,
    {
      provide: ProductVerificationAdapter,
      useExisting: OccProductVerificationAdapter,
    },
    GgAiTroubleshootConnector,
    {
      provide: GgAiTroubleshootAdapter,
      useExisting: OccGgAiTroubleshootAdapter,
    },
    GgFirmwareVerificationConnector,
    {
      provide: GgFirmwareVerificationAdapter,
      useExisting: OccGgFirmwareVerificationAdapter,
    },
  ],
})
export class DataBindingsModule {}
